import img1 from "./images/illustration/video-img-1-1024x512.jpg";

const Work = () => {
  return (
    <>
      <section className="container-fluid" id="demo4">
        <section className="row py-5 pb-5 mt-5 text-center">
          <div className="col-12">
            <h2 className="heading fw-bold mb-4 ">WATCH HOW WE WORK</h2>
            <img src={img1} alt="image not found" className="img-fluid w-100" />
          </div>
        </section>
      </section>
    </>
  );
};

export default Work;
